import './header-nav.scss';
import { h } from 'preact';

export default function HeaderNav({ children }) {
	return (
		<div class="header-nav-container">
			{children}
		</div>
	);
}
